


























































































































































































import VueOptions from '@utils/VueOptions'
import SuperContainerView from '@superUI/Containers/SuperContainerView'
import Back from '@modules/ui/buttons/Back'
import UiList from '@superUI/List/List'
import Trigger from '@modules/ui/triggers/Trigger'
import EventResourceList from '@superUI/ResourceList/EventResourceList'
import OfferResourceList from '@superUI/ResourceList/OfferResourceList'
import PurchaseOrderResourceList from '@superUI/ResourceList/PurchaseOrderResourceList'
import BrandRepResourceList from '@superUI/ResourceList/BrandRepResourceList'
import SponsorResourceList from '@superUI/ResourceList/SponsorResourceList'
import CampaignResourceList from '@superUI/ResourceList/CampaignResourceList'
import ActivationResourceList from '@superUI/ResourceList/ActivationResourceList'
import BrandInfoResourceList from '@superUI/ResourceList/BrandInfoResourceList'
import InvoiceResourceList from '@superUI/ResourceList/InvoiceResourceList'
import FlagsAndTags from '@superUI/FlagsAndTags'

import DiscountTable from '@superUI/Pricing/DiscountTable'
import UpdatePricingModelDiscountTriggerModal from '@triggers/Pricing/UpdatePricingModelDiscountTriggerModal'
import RemovePricingModelDiscountTriggerModal from '@triggers/Pricing/RemovePricingModelDiscountTriggerModal'
import ElongateExpirationDateTriggerModal from '@triggers/Sponsor/ElongateExpirationDateTriggerModal'
import AcceptPendingOfferTriggerModal from '@triggers/Offer/AcceptPendingOfferTriggerModal'
import SetAccountManagerTriggerModal from '@triggers/Sponsor/SetAccountManagerTriggerModal'
import SetAccountCoordinatorTriggerModal from '@triggers/Sponsor/SetAccountCoordinatorTriggerModal'
import MergeSponsorTopOrgsTriggerModal from '@triggers/Sponsor/MergeSponsorTopOrgsTriggerModal'
import MergeSponsorTeamsTriggerModal from '@triggers/Sponsor/MergeSponsorTeamsTriggerModal'

settings =
  name: 'SponsorShow'
  components: {
    SuperContainerView,
    Back,
    UiList,
    Trigger
    EventResourceList,
    OfferResourceList,
    PurchaseOrderResourceList,
    BrandRepResourceList,
    SponsorResourceList,
    CampaignResourceList,
    ActivationResourceList,
    BrandInfoResourceList,
    InvoiceResourceList,
    FlagsAndTags,
    DiscountTable,
    UpdatePricingModelDiscountTriggerModal,
    RemovePricingModelDiscountTriggerModal,
    ElongateExpirationDateTriggerModal,
    AcceptPendingOfferTriggerModal,
    SetAccountManagerTriggerModal,
    SetAccountCoordinatorTriggerModal,
    MergeSponsorTopOrgsTriggerModal,
    MergeSponsorTeamsTriggerModal,
  }

  resources:
    item:
      resourceName: 'sponsor'
      slug: 'sponsors/:sponsorId'
    events:
      resourceName: 'events'
      slug: 'sponsors/:sponsorId/events'
      infinityScroll: true
    offers:
      resourceName: 'offers'
      slug: 'sponsors/:sponsorId/offers'
      infinityScroll: true
    purchase_orders:
      resourceName: 'purchase_orders'
      slug: 'sponsors/:sponsorId/purchase_orders'
      infinityScroll: true
    brand_reps:
      resourceName: 'offers'
      slug: 'sponsors/:sponsorId/brand_reps'
      infinityScroll: true
    teams:
      resourceName: 'sponsors'
      slug: 'sponsors/:sponsorId/sponsors'
      infinityScroll: true
    campaigns:
      resourceName: 'campaigns'
      slug: 'sponsors/:sponsorId/campaigns'
      infinityScroll: true
    activations:
      resourceName: 'activations'
      slug: 'sponsors/:sponsorId/activations'
      infinityScroll: true
    brand_infos:
      resourceName: 'brand_infos'
      slug: 'sponsors/:sponsorId/brand_infos'
      infinityScroll: true
    invoices:
      resourceName: 'invoices'
      slug: 'sponsors/:sponsorId/invoices'
      infinityScroll: true

  vue:
    props: ['sponsorId']

    data: ->
      memberNoteModal:
        modalOptions:
          title: 'Add Member Note'
          inputField:
            label: 'Member Note'
            type: 'el-input'
            model: 'note'
          button:
            label: 'Add'
      
      superNoteModal:
        modalOptions:
          title: 'Add Super Note'
          inputField:
            label: 'Super Note'
            type: 'el-input'
            model: 'note'
          button:
            label: 'Add'

    computed:
      memberNoteTriggerResource: ->
        { key: 'item', triggerName: 'add_member_note', component: this }
      superNoteTriggerResource: ->
        { key: 'item', triggerName: 'add_super_note', component: this }

      publicTagTriggerResource: ->
        { key: 'item', triggerName: 'add_public_tag', component: this }
      privateTagTriggerResource: ->
        { key: 'item', triggerName: 'add_private_tag', component: this }
      untagTriggerResource: ->
        { key: 'item', triggerName: 'untag', component: this }
      privateStatusFlagTriggerResource: ->
        { key: 'item', triggerName: 'add_private_status_flag', component: this }
      unflagTriggerResource: ->
        { key: 'item', triggerName: 'unflag', component: this }


      discountTable: -> @ctxDiscountTable(@item)
      actionsForPricingModelDiscount: ->
        {
          @hiUpdatePricingModelDiscountTrigger,
          @hiRemovePricingModelDiscountTrigger
        }

    methods:
      fetchResource: (state, resourceKey, data = {}, options={}) ->
        @fetchInfinity(state, resourceKey, data, options)

      memberNotePayload: ->
        payload =
          options:
            note: ""
        payload
      
      superNotePayload: ->
        payload =
          options:
            note: ""
        payload

      onItemAddMemberNote: -> @fetch('item')
      onItemAddSuperNote: -> @fetch('item')
      onItemAddPublicTag: -> @fetch('item')
      onItemAddPrivateTag: -> @fetch('item')
      onItemUntag: -> @fetch('item')
      onItemAddPrivateStatusFlag: -> @fetch('item')
      onItemUnflag: -> @fetch('item')

      hiUpdatePricingModelDiscountTrigger: (pricingModel, discount) ->
        payloadOptions = { pricing_model: pricingModel }
        modalOptions = { pricing_model: pricingModel, discount }
        @$refs.updatePricingModelDiscountTrigger.fire(payloadOptions, modalOptions)
      onItemUpdatePricingModelDiscount: (data, response) ->
        @$refs.updatePricingModelDiscountTrigger.close()
        @fetch('item')

      hiRemovePricingModelDiscountTrigger: (pricingModel) ->
        payloadOptions = { pricing_model: pricingModel }
        modalOptions = { pricing_model: pricingModel }
        @$refs.removePricingModelDiscountTrigger.fire(payloadOptions, modalOptions)
      onItemRemovePricingModelDiscount: (data, response) ->
        @$refs.removePricingModelDiscountTrigger.close()
        @fetch('item')

      hiElongateExpirationDateTrigger: ->
        @$refs.elongateExpirationDateTrigger.fire()
      onItemElongateExpirationDate: ->
        @$refs.elongateExpirationDateTrigger.close()

      acceptPendingOfferTrigger: (offer) ->
        payloadOptions = { offer_id: offer.id }
        modalOptions = { offer }
        @$refs.acceptPendingOfferTrigger.fire(payloadOptions, modalOptions)
      onOffersAgreeToTermsAndAccept: ->
        @$refs.acceptPendingOfferTrigger.close()

      hiSetAccountManager: ->
        @setAccountManagerTrigger()
      setAccountManagerTrigger: ->
        payloadOptions = { new_account_manager_id: null }
        modalOptions = { currentAccountManager: @item.account_manager }
        @$refs.setAccountManagerTrigger.fire payloadOptions, modalOptions
      onItemSetAccountManager: ->
        @$refs.setAccountManagerTrigger.close()
        @fetch 'item'

      hiSetAccountCoordinator: ->
        @setAccountCoordinatorTrigger()
      setAccountCoordinatorTrigger: ->
        payloadOptions = { new_account_coordinator_id: null }
        modalOptions = { currentAccountCoordinator: @item.account_coordinator }
        @$refs.setAccountCoordinatorTrigger.fire payloadOptions, modalOptions
      onItemSetAccountCoordinator: ->
        @$refs.setAccountCoordinatorTrigger.close()
        @fetch 'item'

      hiMergeSponsorTopOrgs: ->
        payloadOptions = {}
        modalOptions = { sponsor: @item }
        @$refs.mergeSponsorTopOrgsTrigger.fire payloadOptions, modalOptions
      onItemMergeTopOrgs: ->
        @$refs.mergeSponsorTopOrgsTrigger.close()
      hiMergeSponsorTeams: ->
        payloadOptions = {}
        modalOptions = { sponsor: @item }
        @$refs.mergeSponsorTeamsTrigger.fire payloadOptions, modalOptions
      onItemMergeTeams: ->
        @$refs.mergeSponsorTeamsTrigger.close()

export default VueOptions.vue settings
